module.exports = __WEBPACK_EXTERNAL_MODULE_228__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Pikaday","commonjs2":"pikaday","commonjs":"pikaday","amd":"pikaday"}
// module id = 228
// module chunks = 0